import { render, staticRenderFns } from "./receive-box.vue?vue&type=template&id=78462448&scoped=true&"
import script from "./receive-box.vue?vue&type=script&lang=js&"
export * from "./receive-box.vue?vue&type=script&lang=js&"
import style0 from "./receive-box.vue?vue&type=style&index=0&id=78462448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78462448",
  null
  
)

export default component.exports